import { useIsModernizedSegmentationPageEnabled } from 'modules/segmentation/hooks';
import styled from 'styled-components';
import { Body2, colors, spacing } from 'ui/theme';
import { Link } from 'ui/links';

type Props = {
  id: number;
  name: string;
};

const Li = styled.li`
  list-style-type: disc;
  margin-bottom: ${spacing.threeQuarter};
  margin-left: ${spacing.half};
`;

const ListLink = styled(Link)`
  color: ${colors.textLink};
`;

const path = (id: number) => `/segmentation?emailListId=${id}`;
export const idText = (id: number) => `(List ID ${id})`;

export const ListReferenceListItem = ({ id, name }: Props) => {
  const isModernizedSegmentationPageEnabled = useIsModernizedSegmentationPageEnabled();
  return (
    <Li>
      <Body2>
        <span>{name}</span>&nbsp;
        <ListLink href={path(id)} useReactRouter={isModernizedSegmentationPageEnabled}>
          <span>{idText(id)}</span>
        </ListLink>
      </Body2>
    </Li>
  );
};
